import { Component, OnInit } from '@angular/core';
import { changePassword } from 'src/app/shared/models/VM/changePasswordVM';
import { PasswordService } from '../services/password.service';
import { UserService } from '../services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from 'src/app/shared/services/globals';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { ResponseStatusEnum } from 'src/app/shared/models/system/response-status.enum';

@Component({
  selector: 'app-change-password-form',
  templateUrl: './change-password-form.component.html',
  styleUrls: ['./change-password-form.component.css']
})
export class ChangePasswordFormComponent implements OnInit {


  changePassword:changePassword;
  UserId;
  submitted: boolean;
  isRequesting: boolean;
  errors: string;
  oldPassword;
  confirmPassword;
  constructor( public passwordService: PasswordService,private userService: UserService, private router: Router, private global: Globals, private currentRoute: ActivatedRoute, translate: TranslateService) {

    this.UserId =global.LoginUserId;
    translate.setDefaultLang('AR');
   



   }

  ngOnInit() {
    this.changePassword=  {UserId:"",NewPassword:""};

  }






  private markFormGroupTouched(formGroup: NgForm) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }


  changeUserPassword( value : NgForm ) {
    this.submitted = true;
    this.isRequesting = true;
    this.errors = '';
   

  



    if (value.valid) {
      this.changePassword.UserId = this.UserId;
     
      this.passwordService.ChangePassword(this.changePassword)
        .pipe(finalize(() => { this.isRequesting = false; }))
        .subscribe(
          result => {

            this.global.Messages = result.messages;
            this.global.status = result.status;

            if (this.global.status == ResponseStatusEnum.OK) {
             
              this.router.navigateByUrl("/login");
            }
            else {
              this.errors = this.global.Messages[0].body;
            }
          }
        ),
        (error) => { this.errors = 'ERR' + error;  };
    }
    else
    {
      this.markFormGroupTouched(value);


    }

  }

}
